'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["moduleType", "moduleSpec"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MODULE_TYPES } from 'EmailData/constants/DefaultModulesConstants';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import BaseWidgetPlaceholder from './BaseWidgetPlaceholder';
import MissingSpecPlaceholder from './MissingSpecPlaceholder';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { CenteredLoadingSpinner } from 'LayoutBuilderUI/components/CenteredLoadingSpinner';
import { getTranslatedModuleLabel } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getModuleTypeForPlaceholder } from 'EmailEditorUI/utils/emailPlaceholderUtils';
import I18n from 'I18n';
import { RichTextIcon } from 'foundations-assets/icons/components/RichTextIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = ({
  pastDelay
}) => {
  return pastDelay ? /*#__PURE__*/_jsx(NamespaceWrapper, {
    children: /*#__PURE__*/_jsx(CenteredLoadingSpinner, {})
  }) : null;
};
const AsyncImageWidgetPlaceholder = makeAsyncComponent(() => import( /* webpackChunkName: 'image-widget-placeholders' */'LayoutBuilderUI/components/placeholders/widgets/ImageWidgetPlaceholder'), {
  LoadingComponent
});
const AsyncVideoWidgetPlaceholder = makeAsyncComponent(() => import( /* webpackChunkName: 'video-widget-placeholders' */'LayoutBuilderUI/components/placeholders/widgets/VideoWidgetPlaceholder'), {
  LoadingComponent
});
const AsyncEmailProductsPlaceholder = makeAsyncComponent(() => import( /* webpackChunkName: 'email-products-widget-placeholders' */'LayoutBuilderUI/components/placeholders/widgets/EmailProductsWidgetPlaceholder'), {
  LoadingComponent
});
const AsyncPaymentsButtonPlaceholder = makeAsyncComponent(() => import( /* webpackChunkName: 'email-payments-button-placeholders' */'LayoutBuilderUI/components/placeholders/widgets/EmailPaymentsButtonPlaceholder'), {
  LoadingComponent
});
const getPlaceholderText = moduleType => {
  switch (moduleType) {
    case MODULE_TYPES.RICH_TEXT:
      return I18n.text('layoutBuilder.placeholders.richText');
    default:
      return null;
  }
};
const getIcon = moduleType => {
  switch (moduleType) {
    case MODULE_TYPES.RICH_TEXT:
      return RichTextIcon;
    default:
      return null;
  }
};
const mapStateToProps = (state, ownProps) => {
  const moduleType = getModuleTypeForPlaceholder(ownProps.element);
  return {
    moduleType,
    label: getPlaceholderText(moduleType) || getTranslatedModuleLabel(state, ownProps.moduleSpec.name, ownProps.moduleSpec.moduleId)
  };
};
class WidgetPlaceholder extends Component {
  render() {
    const _this$props = this.props,
      {
        moduleType,
        moduleSpec
      } = _this$props,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (!moduleSpec || !moduleSpec.fields || moduleSpec.fields.length === 0) {
      return /*#__PURE__*/_jsx(MissingSpecPlaceholder, {});
    }
    switch (moduleType) {
      case MODULE_TYPES.IMAGE:
      case MODULE_TYPES.LOGO:
        return /*#__PURE__*/_jsx(AsyncImageWidgetPlaceholder, Object.assign({
          moduleSpec: moduleSpec,
          moduleType: moduleType
        }, otherProps));
      case MODULE_TYPES.EMAIL_VIDEO:
        return /*#__PURE__*/_jsx(AsyncVideoWidgetPlaceholder, Object.assign({
          moduleSpec: moduleSpec
        }, otherProps));
      case MODULE_TYPES.EMAIL_PRODUCTS:
        return /*#__PURE__*/_jsx(AsyncEmailProductsPlaceholder, {
          elementId: this.props.element.get('id')
        });
      case MODULE_TYPES.BUTTON:
        return /*#__PURE__*/_jsx(AsyncPaymentsButtonPlaceholder, {});
      case MODULE_TYPES.WEB_VERSION_LINK:
        return null;
      default:
        return /*#__PURE__*/_jsx(BaseWidgetPlaceholder, Object.assign({
          moduleSpec: moduleSpec,
          overrideIcon: getIcon(moduleType)
        }, otherProps));
    }
  }
}
WidgetPlaceholder.propTypes = {
  moduleType: PropTypes.string,
  moduleSpec: PropTypes.object,
  element: PropTypes.object,
  label: PropTypes.string
};
export default connect(mapStateToProps)(WidgetPlaceholder);